import Axios from '../Axios';
import { fetchUser } from '../utils/fetchUser';

export const getLogs = async ( fechaStart, fechaEnd, opcion , accion , idUsuario, numeroSolicitud ) => {
    try {
      const userInfo = fetchUser();
      
      const {data}  = await Axios.get(
        `/log?empresa=${userInfo.empresa}&fechaStart=${fechaStart}&fechaEnd=${fechaEnd}&opcion=${opcion}&accion=${accion}&idUsuario=${idUsuario}&numeroSolicitud=${numeroSolicitud}`);
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const crearLog = async (logData) => {
    try {
      const userInfo = fetchUser();
      logData.empresa = userInfo.empresa;

        const {data}  = await Axios.post(
            '/log', logData
        );
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };